module.exports = __webpack_public_path__ + "static/media/Annie Stefanec Headshot.41693091.png";